import { useState } from 'react'

import { useEffect } from 'modules/core/hooks/useEffect'

import { useHapiElementsContext } from 'modules/ats/components/HapiElementsLoader'
import {
  type Campaign,
  CampaignWithProducts,
  buildCampaignWithProducts,
} from 'modules/ats/lib/vonq'

type CampaignProductGroups = Record<string, CampaignWithProducts[]>

export const useGetCampaignsGroupedByJob = () => {
  const { elementsLoaded } = useHapiElementsContext()
  const [loading, setLoading] = useState(false)
  const [campaigns, setCampaigns] = useState<CampaignProductGroups>({})

  const mapCampaigns = (arr: Campaign[]) => {
    const group: CampaignProductGroups = {}

    for (const campaign of arr) {
      const jobId = campaign.labels?.factorialJobId

      if (!jobId) {
        continue
      }

      if (!group[jobId]) {
        group[jobId] = []
      }

      campaign.orderedProducts.forEach((productId: string) => {
        group[jobId]?.push(buildCampaignWithProducts(campaign))
      })
    }

    return group
  }

  useEffect(() => {
    if (!elementsLoaded) {
      return
    }

    async function fetchData() {
      const response = await window.hapi.campaign.service?.getCampaigns.run(0)

      if (!response) {
        return
      }

      setCampaigns(mapCampaigns(response.data))
    }

    fetchData()

    window.hapi.campaign.state.campaignsAreLoading.onChange((newValue: boolean) => {
      setLoading(newValue)
    })

    window.hapi.campaign.state?.campaigns.onChange((newValue: Campaign[]) => {
      setCampaigns(mapCampaigns(newValue))
    })
  }, [elementsLoaded])

  return { loading, campaigns }
}
